import { useMemo } from 'react'

import { EmailDomainTranslator } from 'src/translators/EmailDomainTranslator'
import { useGetEmailDomainsQuery } from 'src/types/generated'

export const useGetEmailDomains = () => {
  const { loading, data, error, refetch } = useGetEmailDomainsQuery()

  const emailDomains = useMemo(() => {
    const domains = data?.emailDomains?.emailDomains ?? []
    return EmailDomainTranslator.toEntities(domains)
  }, [data])

  return { loading, emailDomains, error, refetch }
}
